import { PageEvent } from '@spartacus/storefront'

export class ProductFiltersEvent extends PageEvent {

    static readonly type = 'ProductFiltersEvent'

    eventAction?: string
    eventLabel?: string
}
